/**
 * @desc 修改
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.platformLogistics.update.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformLogistics/update`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
